import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { FaPrint, FaFileExcel, FaCopy, FaSearch, FaEye } from 'react-icons/fa';

const ViewGenerateCertificate = () => {
    const navigate = useNavigate();
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const certsRef = ref(db, 'ekamwatapzp/Certificates');
        const unsubscribe = onValue(certsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setCertificates(list);
            } else {
                setCertificates([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredData = certificates.filter(cert =>
        cert.userName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        cert.regNo?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col ">
                {/* Header Section */}
                <div className="px-6 py-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <h1 className="text-xl font-medium text-gray-700">व्हिव जनरेट सर्टिफिकेट</h1>
                    <div className="flex items-center text-sm font-medium text-gray-500 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-600 font-semibold">व्हिव जनरेट सर्टिफिकेट</span>
                    </div>
                </div>

                <div className="px-6 pb-12">
                    <div className="max-w-[100%] mx-auto bg-white rounded-lg shadow-sm border border-gray-200 p-6 overflow-hidden">

                        {/* Table Controls */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                            <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Copy</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Excel</button>
                                <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium transition-colors">Print</button>
                            </div>

                            <div className="flex items-center gap-2">
                                <label className="text-sm font-medium text-gray-600">Search:</label>
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                                />
                            </div>
                        </div>

                        {/* Data Table */}
                        <div className="overflow-x-auto border border-gray-200">
                            <table className="w-full text-left text-sm border-collapse">
                                <thead>
                                    <tr className="bg-white text-gray-800 font-bold divide-x divide-gray-200 border-b border-gray-200">
                                        <th className="px-4 py-3 min-w-[50px]"># <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">User Name <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Qualification <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[100px]">Amount <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Registration class <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Certificate term <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Work Eligibility <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Registration No. <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[150px]">Address <span className="text-[10px] ml-1">↑↓</span></th>
                                        <th className="px-4 py-3 min-w-[100px]">Action <span className="text-[10px] ml-1">↑↓</span></th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="10" className="px-4 py-10 text-center text-gray-500 italic">
                                                Loading data...
                                            </td>
                                        </tr>
                                    ) : filteredData.length > 0 ? (
                                        filteredData.map((cert, index) => (
                                            <tr key={cert.id} className="hover:bg-gray-50 divide-x divide-gray-200">
                                                <td className="px-4 py-3 font-medium">{index + 1}</td>
                                                <td className="px-4 py-3">{cert.userName}</td>
                                                <td className="px-4 py-3">{cert.qualification}</td>
                                                <td className="px-4 py-3 text-emerald-600 font-semibold">{cert.amount}</td>
                                                <td className="px-4 py-3">{cert.regClass}</td>
                                                <td className="px-4 py-3">{cert.certTerm}</td>
                                                <td className="px-4 py-3">{cert.eligibility}</td>
                                                <td className="px-4 py-3 font-bold text-blue-600">{cert.regNo}</td>
                                                <td className="px-4 py-3 text-xs line-clamp-2 md:line-clamp-none" title={cert.address}>{cert.address}</td>
                                                <td className="px-4 py-3">
                                                    <button className="text-blue-500 hover:text-blue-700 transition-colors" title="पहा">
                                                        <FaEye size={16} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className="bg-gray-50/50">
                                            <td colSpan="10" className="px-4 py-8 text-center text-gray-500">
                                                No data available in table
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination Section */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-6 text-sm text-gray-600 font-medium">
                            <p>Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries</p>
                            <div className="flex shadow-sm rounded-md overflow-hidden border border-gray-300">
                                <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-r border-gray-300 transition-colors">Previous</button>
                                <button className="px-4 py-1.5 bg-white hover:bg-gray-50 transition-colors">Next</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </InchargeLayout>
    );
};

export default ViewGenerateCertificate;
